// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"codetable-list-items__visuallyhidden--AFVFi","focusable":"codetable-list-items__focusable--Ce1G6","deleting":"codetable-list-items__deleting--eUA8x"};